var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50562 3.87241L1.50723 3.87453L1.51725 3.88755C1.52691 3.9 1.54249 3.91984 1.56382 3.94631C1.60652 3.99927 1.67218 4.07863 1.75958 4.17831C1.93462 4.37792 2.19557 4.65752 2.53269 4.96909C3.21059 5.59561 4.17695 6.33326 5.35413 6.82064C6.52378 7.30491 7.89348 7.53973 9.41093 7.18278C10.9309 6.82524 12.6672 5.85787 14.5388 3.81892C14.8024 3.53172 15.2489 3.51262 15.5361 3.77624C15.8233 4.03987 15.8424 4.4864 15.5788 4.7736C13.5626 6.97009 11.5902 8.12044 9.73419 8.55704C7.87561 8.99423 6.20188 8.69962 4.81408 8.12503C3.4338 7.55356 2.32869 6.70292 1.57448 6.00587C1.19554 5.65565 0.900277 5.33964 0.698112 5.10909C0.596918 4.99369 0.518728 4.89933 0.464727 4.83234C0.437717 4.79884 0.41673 4.77215 0.401915 4.75305C0.394506 4.74351 0.388638 4.73586 0.384328 4.7302L0.379034 4.72323L0.377268 4.72088L0.376605 4.72C0.376336 4.71964 0.37609 4.71931 0.941154 4.29626L0.37609 4.71931C0.142445 4.40724 0.206026 3.96484 0.518102 3.7312C0.829903 3.49776 1.27179 3.56102 1.5056 3.87238",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.11787 9.42965C8.50772 9.42965 8.82375 9.74568 8.82375 10.1355V12.7669C8.82375 13.1567 8.50772 13.4727 8.11787 13.4727C7.72802 13.4727 7.41199 13.1567 7.41199 12.7669V10.1355C7.41199 9.74568 7.72802 9.42965 8.11787 9.42965Z",
    fill: "#FFB6BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10684 8.63237C4.47394 8.76359 4.66516 9.16756 4.53394 9.53466L3.61967 12.0924C3.48845 12.4595 3.08448 12.6507 2.71738 12.5195C2.35028 12.3883 2.15906 11.9843 2.29028 11.6172L3.20455 9.05947C3.33577 8.69237 3.73974 8.50115 4.10684 8.63237Z",
    fill: "#FFB6BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1205 8.63514C12.4857 8.49869 12.8924 8.68413 13.0288 9.04932L13.9776 11.5886C14.114 11.9538 13.9286 12.3605 13.5634 12.4969C13.1982 12.6334 12.7915 12.4479 12.6551 12.0828L11.7063 9.54343C11.5699 9.17824 11.7553 8.77159 12.1205 8.63514Z",
    fill: "#FFB6BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.fc86b6e4af39f6d0a84a670459312e8e.svg";
export { ForwardRef as ReactComponent };